import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module';
import { namespace } from 'vuex-class';

export const MODULE_NAME = 'ConstantsModule';

class ConstantsState {
  list = {
    chatButtonLink: 'help.chatButton.link',
    chatButtonName: 'help.chatButton.name',
    title: 'help.common.title',
    copyright: 'help.common.copyright',
    contacts: 'help.contacts',
    lastModified: 'help.lastModifiedDate',
    '404Link': 'help.common.404.link',
    '404Title': 'help.common.404.title',
    '404Content': 'help.common.404.content',
    startBetting: 'help.common.startBetting',
    languageTile: 'help.common.language',
    chooseCurrency: 'help.common.payments.chooseCurrency',
    languagePopular: 'help.common.languages.popular',
    otherLanguages: 'help.common.languages.otherLanguages',
    sections: 'help.common.menu.sections',
    commonInfo: 'help.common.menu.commonInfo',
    chooseCountry: 'help.common.payments.chooseCountry',
    nothingFound: 'help.common.payments.nothingFound',
    noPaymentMethods: 'help.common.payments.noPaymentMethods',
    chooseAnotherData: 'help.common.payments.chooseAnotherData',
    paymentMethod: 'help.common.payments.paymentMethod',
    deposit: 'help.common.payments.deposit',
    withdraw: 'help.common.payments.withdraw',
    availableFor: 'help.common.payments.availableFor',
    currenciesCount: 'help.common.payments.currenciesCount',
    acceptedCurrencies: 'help.common.payments.acceptedCurrencies',
    min: 'help.common.payments.min',
    max: 'help.common.payments.max',
    viaOtherPaymentMethods: 'help.common.payments.viaOtherPaymentMethods',
    processingTemporarilyUnavailable: 'help.common.payments.processingTemporarilyUnavailable',
    paymentOptionsNotSet: 'help.common.payments.paymentOptionsNotSet',
    otherCurrencies: 'help.common.payments.otherCurrencies',
    otherCountries: 'help.common.payments.otherCountries',
    searchTitle: 'help.common.payments.search',
    paymentsContent: 'help.common.payments.header',
    paymentsFooter: 'help.common.payments.footer',
    paymentsDescription: 'help.PAYMENT_OPTIONS_ASTERISK_NOTE',
    searchBlockPlaceholder: 'help.search.placeholder',
    searchBlockButton: 'help.search.buttonLabel',
    searchBlockCancel: 'help.search.cancelLabel',
    searchPageTitle: 'help.search.title',
    searchPageNoResultsTitle: 'help.search.noResultsTitle',
    searchPageNoResultsText: 'help.search.noResultsText',
    searchPagePaginatorGoLabel: 'help.search.paginatorLabel',
    searchPagePaginatorOffLabel: 'help.search.paginatorOfLabel',
    searchPagePleaseWait: 'help.search.pleaseWait',
    searchPageEnterMoreCharacters: 'help.search.EnterMoreCharacters',
    e500Title: 'help.common.e500.title',
    e500Text: 'help.common.e500.text',
    paymentsHeader: 'help.payments.header',
    zadarmaCall: 'help.zadarmaCall',
    zadarmaConnection: 'help.zadarmaConnection',
    zadarmaEnded: 'help.zadarmaEnded',
    zadarmaFinishCall: 'help.zadarmaFinishCall',
    zadarmaNowebrtc: 'help.zadarmaNowebrtc',
    zadarmaBuzy: 'help.zadarmaBuzy',
    zadarmaGreementTtle: 'help.zadarmaGreementTtle',
    zadarmaAgreementLink: 'help.zadarmaAgreementLink',
    zadarmaAgreementText: 'help.zadarmaAgreementText',
    zadarmaAfterHours: 'help.zadarmaAfterHours',
    zadarmaAway: 'help.zadarmaAway',
    zadarmaBusy: 'help.zadarmaBusy',
    zadarmaCallmeButton: 'help.zadarmaCallmeButton',
    zadarmaCallsPer30MinutesAlert: 'help.zadarmaCallsPer30MinutesAlert',
    zadarmaCallsPerNumber1Day: 'help.zadarmaCallsPerNumber1Day',
    zadarmaCallsPerNumber1Hour: 'help.zadarmaCallsPerNumber1Hour',
    zadarmaCantTalkNow: 'help.zadarmaCantTalkNow',
    zadarmaComfortableTime: 'help.zadarmaComfortableTime',
    zadarmaDeferred: 'help.zadarmaDeferred',
    zadarmaErrNumberFormat: 'help.zadarmaErrNumberFormat',
    zadarmaFailButton: 'help.zadarmaFailButton',
    zadarmaForbiddenCountry: 'help.zadarmaForbiddenCountry',
    zadarmaMainButtonText: 'help.zadarmaMainButtonText',
    zadarmaOff: 'help.zadarmaOff',
    zadarmaOn: 'help.zadarmaOn',
    zadarmaPlaceholder: 'help.zadarmaPlaceholder',
    zadarmaRateCall: 'help.zadarmaRateCall',
    zadarmaRepeatCall: 'help.zadarmaRepeatCall',
    zadarmaSuccessButton: 'help.zadarmaSuccessButton',
    zadarmaTalkNow: 'help.zadarmaTalkNow',
    zadarmaThanksForRequest: 'help.zadarmaThanksForRequest',
    zadarmaTitleAway: 'help.zadarmaTitleAway',
    zadarmaTitleDeferred: 'help.zadarmaTitleDeferred',
    zadarmaTitleOff: 'help.zadarmaTitleOff',
    zadarmaTitleOn: 'help.zadarmaTitleOn',
    zadarmaToday: 'help.zadarmaToday',
  };

  isLoaded = false;
}

class ConstantsGetters extends Getters<ConstantsState> {
  get isLoaded() {
    return this.state.isLoaded;
  }

  get zadarmaCallBackDictionary(): Record<string, string> {
    return {
      agreement_title: this.state.list.zadarmaGreementTtle,
      agreement_link: this.state.list.zadarmaAgreementLink,
      agreement_text: this.state.list.zadarmaAgreementText,
      after_hours: this.state.list.zadarmaAfterHours,
      away: this.state.list.zadarmaAway,
      busy: this.state.list.zadarmaBusy,
      callme_button: this.state.list.zadarmaCallmeButton,
      calls_per_30_minutes_alert: this.state.list.zadarmaCallsPer30MinutesAlert,
      calls_per_number_1_day: this.state.list.zadarmaCallsPerNumber1Day,
      calls_per_number_1_hour: this.state.list.zadarmaCallsPerNumber1Hour,
      cant_talk_now: this.state.list.zadarmaCantTalkNow,
      comfortable_time: this.state.list.zadarmaComfortableTime,
      deferred: this.state.list.zadarmaDeferred,
      err_number_format: this.state.list.zadarmaErrNumberFormat,
      fail_button: this.state.list.zadarmaFailButton,
      forbidden_country: this.state.list.zadarmaForbiddenCountry,
      main_button_text: this.state.list.zadarmaMainButtonText,
      off: this.state.list.zadarmaOff,
      on: this.state.list.zadarmaOn,
      placeholder: this.state.list.zadarmaPlaceholder,
      rate_call: this.state.list.zadarmaRateCall,
      repeat_call: this.state.list.zadarmaRepeatCall,
      success_button: this.state.list.zadarmaSuccessButton,
      talk_now: this.state.list.zadarmaTalkNow,
      thanks_for_request: this.state.list.zadarmaThanksForRequest,
      title_away: this.state.list.zadarmaTitleAway,
      title_deferred: this.state.list.zadarmaTitleDeferred,
      title_off: this.state.list.zadarmaTitleOff,
      title_on: this.state.list.zadarmaTitleOn,
      today: this.state.list.zadarmaToday,
    };
  }

  get zadarmaCallDictionary(): ZadarmaCreateLangSettings {
    return {
      txt_greeting: this.state.list.zadarmaCall,
      txt_nowebrtc: '',
      texts: {
        greeeting: this.state.list.zadarmaCall,
        call: this.state.list.zadarmaCall,
        connection: this.state.list.zadarmaConnection,
        ended: this.state.list.zadarmaEnded,
        finishCall: this.state.list.zadarmaFinishCall,
        nowebrtc: this.state.list.zadarmaNowebrtc,
        buzy: this.state.list.zadarmaBuzy,
      },
    };
  }

  get paymentsContent() {
    return this.state.list.paymentsContent;
  }

  get paymentsFooter() {
    return this.state.list.paymentsFooter;
  }

  get paymentsDescription() {
    return this.state.list.paymentsDescription;
  }

  get searchTitle() {
    return this.state.list.searchTitle;
  }

  get otherCountries() {
    return this.state.list.otherCountries;
  }

  get otherCurrencies() {
    return this.state.list.otherCurrencies;
  }

  get chooseCurrency() {
    return this.state.list.chooseCurrency;
  }

  get viaOtherPaymentMethods() {
    return this.state.list.viaOtherPaymentMethods;
  }

  get processingTemporarilyUnavailable() {
    return this.state.list.processingTemporarilyUnavailable;
  }

  get paymentOptionsNotSet() {
    return this.state.list.paymentOptionsNotSet;
  }

  get max() {
    return this.state.list.max;
  }

  get min() {
    return this.state.list.min;
  }

  get acceptedCurrencies() {
    return this.state.list.acceptedCurrencies;
  }

  get currenciesCount() {
    return this.state.list.currenciesCount;
  }

  get availableFor() {
    return this.state.list.availableFor;
  }

  get withdraw() {
    return this.state.list.withdraw;
  }

  get deposit() {
    return this.state.list.deposit;
  }

  get paymentMethod() {
    return this.state.list.paymentMethod;
  }

  get chooseAnotherData() {
    return this.state.list.chooseAnotherData;
  }

  get noPaymentMethods() {
    return this.state.list.noPaymentMethods;
  }

  get nothingFound() {
    return this.state.list.nothingFound;
  }

  get languageTile() {
    return this.state.list.languageTile;
  }

  get languagePopular() {
    return this.state.list.languagePopular;
  }

  get otherLanguages() {
    return this.state.list.otherLanguages;
  }

  get sections() {
    return this.state.list.sections;
  }

  get commonInfo() {
    return this.state.list.commonInfo;
  }

  get copyright() {
    return this.state.list.copyright;
  }

  get chooseCountry() {
    return this.state.list.chooseCountry;
  }

  get contacts() {
    return this.state.list.contacts;
  }

  get title() {
    return this.state.list.title;
  }

  get startBetting() {
    return this.state.list.startBetting;
  }

  get Page404() {
    return {
      link: this.state.list['404Link'],
      title: this.state.list['404Title'],
      content: this.state.list['404Content'],
    };
  }

  get lastModified() {
    return this.state.list.lastModified;
  }

  get chat() {
    return {
      url: this.state.list.chatButtonLink,
      label: this.state.list.chatButtonName,
    };
  }

  get list() {
    return Object.values(this.state.list).map((item) => item);
  }
}

class ConstantsMutations extends Mutations<ConstantsState> {
  setConstantsState(state: boolean) {
    this.state.isLoaded = state;
  }
}

class ConstantsActions extends Actions<
  ConstantsState,
  ConstantsGetters,
  ConstantsMutations,
  ConstantsActions
> {}

// Экспорт модуля
export const ConstantsModule = new Module({
  state: ConstantsState,
  getters: ConstantsGetters,
  mutations: ConstantsMutations,
  actions: ConstantsActions,
});

export const ConstantsModuleMapper = createMapper(ConstantsModule);

export const ConstantsNS = namespace(MODULE_NAME);
